import { AppError } from "./app-error";

export class ConfigurationEntryNotFoundError extends AppError {}
